<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headers"
      :paginate="true"
      :items="itemsEmpresas"
      :items-per-page="8"
      :loading="loading"
      item-key="id"
      :currentPage="currentPage"
      :lastPage="lastPage"
      @pageChange="fetchEmpresas({ ...filter, page: $event })"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="8" lg="8" class="pa-0">
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pa-0">
            <MenuFilterSearchTable
              :placeholder="'Buscar por sigla ou CNPJ'"
              :textQuery="'sigla'"
              :codQuery="'cnpj'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>
      <!-- ---------------- header ---------------- -->
      <template v-slot:header.nome="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="`${header.text}`"
            query="nome"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.sigla="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="`${header.text}`"
            query="sigla"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>
      <!-- ---------------- items ---------------- -->
      <template v-slot:item.actions="{ item }">
        <div
          v-can:permission="'nfe-ncm-centro-custo#store'"
          class="d-flex justify-center"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="navigate(item)">
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </template>
            <span>Vincular centros de custo</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.nome="{ item }">
        <div class="d-flex justify-center">
          {{ item.nome.toUpperCase() || "" }}
        </div>
      </template>
    </BaseDataTable>
  </v-card>
</template>

<script>
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import empresas from "@/services/http/empresas/index";
export default {
  components: {
    MenuFilter,
    BaseDataTable,
    MenuFilterSearchTable
  },

  data() {
    return {
      loading: false,
      filter: {},
      itemsEmpresas: [],

      lastPage: 1,
      currentPage: 1,
      headers: [
        {
          text: "Sigla",
          value: "sigla",
        },
        {
          text: "Nome",
          value: "nome",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "Cnpj",
          value: "cnpj",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
        },
      ],
    };
  },

  watch: {
    filter(value) {
      this.fetchEmpresas(value);
    },
  },
  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    formatText(text) {
      return text.replaceAll('"', "");
    },

    navigate(item) {
      this.$router.push(`/empresas/${item.id_empresa_gc1}/centro-custo`);
    },

    async fetchEmpresas(filters = {}) {
      try {
        this.loading = true;
        let { data } = await empresas().show({
          ...filters,
          segmento_id: [1, 2],
          per_page: 8,
        });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.itemsEmpresas = data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },

  created() {
    this.fetchEmpresas();
  },
};
</script>
